import React from 'react'
import { Outlet } from 'react-router-dom';

// ksm_backend/ksm_frontend 포팅(2026-10-19, bito 3단계) — 메뉴/권한 통합 관리 화면의 바깥 틀.
const MenuMngPage = () => {
  return <Outlet/>
}

export default MenuMngPage
